import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { getSubPermissions } from "common/isPermissionEnabled"
import { isFulfillmentSubPermissionEnabled } from "utils/fulfillmentPermissions"

// Same customer-facing names as the Orders pages (getSystemOrderStatusLabel).
// One template covers every order type, so statuses 3 and 4 list the names
// for each order type the plan allows.
const STATUS_LABELS = {
  1: ["Accepted"],
  2: ["Preparing"],
  3: { collection: "Ready for Pickup", delivery: "Out for Delivery" },
  4: { collection: "Picked Up", delivery: "Delivered" },
  5: ["Cancelled"],
  6: ["Cancelled by Customer"],
}

const useNotificationStatusLabel = () => {
  const { t } = useTranslation()
  const { userRole, accountType, accountScope } = useSelector(
    state => state.Login
  )
  const branchSubPermissions = getSubPermissions(
    userRole,
    5,
    "branchLocations_3",
    accountType,
    accountScope
  )
  const hasDelivery = isFulfillmentSubPermissionEnabled(
    branchSubPermissions,
    "enableDelivery"
  )
  const hasCollection =
    isFulfillmentSubPermissionEnabled(branchSubPermissions, "enablePickup") ||
    isFulfillmentSubPermissionEnabled(branchSubPermissions, "enableCurbside")

  return actionType => {
    const labels = STATUS_LABELS[actionType]
    if (!labels) return ""
    if (Array.isArray(labels)) return t(labels[0])

    const names = []
    if (hasCollection || !hasDelivery) names.push(t(labels.collection))
    if (hasDelivery) names.push(t(labels.delivery))
    return names.join(" / ")
  }
}

export default useNotificationStatusLabel
